import { Aggregate as View } from 'ui-components/components/molecules/DefaultVisualization/Aggregate'
import { useNumericProperties } from '~map-preview/states/map'
import { useMapSettingsStore } from '~map-preview/states/mapSettings'
import { Aggregate as TypeAggregate } from '~map-preview/types/__generated/gql/graphql'

import { useUpdateDefaultVisualization } from '~map-settings/hooks/useUpdateDefaultVisualization'

export const Aggregate = () => {
  const { defaultVisualization } = useMapSettingsStore()
  const { update } = useUpdateDefaultVisualization()
  const numericProperties = useNumericProperties()

  const properties = [
    { label: 'Location count', name: 'count' } as any,
    ...numericProperties
  ]

  const handleChange = async (event) => {
    const tmp = {
      ...defaultVisualization.aggregate,
      aggregate: event.target.value,
      display: '2D'
    }
    await update(tmp)
  }

  const selected: TypeAggregate | undefined =
    defaultVisualization &&
    (Object.values(defaultVisualization)[0] as TypeAggregate | undefined)

  return (
    <View
      value={selected?.aggregate}
      options={properties}
      onChange={handleChange}
    />
  )
}
